import tw, { styled } from 'twin.macro';

const MarkdownHeading3 = styled.h3`
  ${tw`text-xl w-full py-2`}

  .message-type-markdown & {
    ${tw`py-0 border-b-0 m-0`}
  }
`;

export default MarkdownHeading3;
